import angular from 'angular';
import contactIdentificationTable from './contactIdentificationTable';

export default angular
  .module('components.contactIdentificationTable', [])
  .component('contactIdentificationTable', contactIdentificationTable).name;
